// ActiveCampaign form handler
(function() {
    'use strict';

    // Global variable to track the currently submitting form
    window._ac_current_form = null;

    // Global callbacks that ActiveCampaign expects
    window._show_thank_you = function(id, message, trackcmp_url, email) {
        var form = window._ac_current_form;
        if (!form) return;

        // Remove loading state
        form.classList.remove('loading');
        form.classList.add('success');

        // Track successful subscription in Google Analytics
        if (typeof gtag === 'function') {
            gtag('event', 'email_subscribe');
        }

        // Hide legal text and show message
        var legalText = form.querySelector('.form-legal-text');
        if (legalText) {
            legalText.style.display = 'none';
        }

        // Find message element
        var messageEl = form.querySelector('.form-message, .gh-newsletter-cta-message');
        if (messageEl) {
            messageEl.textContent = 'Thanks for subscribing!';
            messageEl.classList.add('success');
            messageEl.classList.remove('error');
            messageEl.style.display = 'block';
        }

        // Re-enable submit button
        var submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = false;
        }

        // Clear current form reference
        window._ac_current_form = null;
    };

    window._show_error = function(id, message, html) {
        var form = window._ac_current_form;
        if (!form) return;

        // Remove loading state
        form.classList.remove('loading');

        // Hide legal text and show message
        var legalText = form.querySelector('.form-legal-text');
        if (legalText) {
            legalText.style.display = 'none';
        }

        // Find message element
        var messageEl = form.querySelector('.form-message, .gh-newsletter-cta-message');
        if (messageEl) {
            messageEl.textContent = message || 'Sorry, something went wrong. Please try again.';
            messageEl.classList.add('error');
            messageEl.classList.remove('success');
            messageEl.style.display = 'block';
        }

        // Re-enable submit button
        var submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = false;
        }

        window._ac_current_form = null;
    };

    // Preference center callback (optional, for completeness)
    window._show_pc_confirmation = function(id, header, detail, show, email) {
        // Not needed for simple subscription forms
        window._show_thank_you(id, detail, null, email);
    };

    // Form serialization function (from ActiveCampaign example)
    function serializeForm(form) {
        if (!form || form.nodeName !== "FORM") return '';

        var q = [];
        for (var i = 0; i < form.elements.length; i++) {
            var elem = form.elements[i];
            if (elem.name === "") continue;

            switch (elem.nodeName) {
                case "INPUT":
                    switch (elem.type) {
                        case "text":
                        case "email":
                        case "hidden":
                        case "password":
                        case "button":
                        case "reset":
                        case "submit":
                            q.push(elem.name + "=" + encodeURIComponent(elem.value));
                            break;
                        case "checkbox":
                        case "radio":
                            if (elem.checked) {
                                q.push(elem.name + "=" + encodeURIComponent(elem.value));
                            }
                            break;
                    }
                    break;
                case "TEXTAREA":
                    q.push(elem.name + "=" + encodeURIComponent(elem.value));
                    break;
                case "SELECT":
                    q.push(elem.name + "=" + encodeURIComponent(elem.value));
                    break;
            }
        }
        return q.join("&");
    }

    // Script loading function
    function loadScript(url, onError) {
        var script = document.createElement('script');
        script.src = url;
        script.onerror = function() {
            if (onError) onError();
        };
        document.head.appendChild(script);
    }

    // Initialize form handlers when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        var forms = document.querySelectorAll('form[action*="activehosted.com"]');

        forms.forEach(function(form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                // Store reference to current form
                window._ac_current_form = form;

                var submitButton = form.querySelector('button[type="submit"]');
                var messageEl = form.querySelector('.form-message, .gh-newsletter-cta-message');
                var legalText = form.querySelector('.form-legal-text');

                // Clear previous messages and hide message element
                if (messageEl) {
                    messageEl.textContent = '';
                    messageEl.classList.remove('success', 'error');
                    messageEl.style.display = 'none';
                }

                // Show legal text if it was hidden
                if (legalText) {
                    legalText.style.display = 'block';
                }

                // Add loading state
                form.classList.add('loading');
                if (submitButton) {
                    submitButton.disabled = true;
                }

                // Serialize form data
                var serialized = serializeForm(form);

                // Submit via JSONP (ActiveCampaign will call global callbacks)
                loadScript(
                    'https://shockbyte.activehosted.com/proc.php?' + serialized + '&jsonp=true',
                    function() {
                        // Script load error
                        window._show_error(null, 'Network error. Please try again.');
                    }
                );
            });
        });
    });
})();
